import API from '@/api'
import { resolve } from 'mathjs'

const state = {
  token: '',
  userId: '',
  userName: '',
  email: '',
  phone: '',
  jti: '',
  authorities: '',
  isAuthentication: false, // 邮箱是否验证

  addressList: [],
  countrySelectList: [], // 国家下拉框列表
  balance: 0, // 用户余额
  shoppingCartSkuNum: 0, // 购物车列表sku数量
  promotionCode: '', // 网盟平台推广码
  promotionSource: '', // 来源自哪个平台
  carrierSelectList: [], // 承运商下拉列表
  statusSelectList: [], // 订单状态下拉
  cancelReasonSelectList: [], // 退款原因下拉
  selectedKKProductId: '', // 首页点击产品ID
  platformOptions: [], // 平台下拉
  categoryTree: [], // 品类tree
  customNavList: [], // 自定义导航列表
  newFunctionIsRead: false,

  cartList: [],
  fastLogin: false, // 订单界面 快速创建用户
  currency: 'USD',
  currencyRate: 1,
  currencySymbol: '$',

  adBar: {}, // 商城广告栏
  festivaiActivity: [], // 节日活动数组
  albumTopList: [], // header顶部固定专辑
  ipInfoObjec: {},
  shoppingCarIsNeedTips: true,
  shoppingCarIsNeedTipsUserId: undefined
}
const mutations = {
  set(state, object) {
    Object.assign(state, object)
  }
}
/**
this.$store.dispatch('common/getAddressList').then(result => {
  console.log(result)
})
 */
const actions = {
  /**
   * 获取用户收货地址列表
   */
  getAddressList({ state, commit }, type) {
    return new Promise((resolve, reject) => {
      API.getAddressList(type).then(result => {
        commit('set', {
          addressList: result.data || []
        })
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取用户余额
   * this.$store.state.common.balance
   * this.$store.dispatch('common/getBalance')
   */
  getBalance({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getBalance().then(result => {
        const balance = result.data.balance || 0
        commit('set', { balance })
        resolve(balance)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取国家下拉框列表
   * this.$store.state.common.countrySelectList
   * this.$store.dispatch('common/getCountrySelectList')
   */
  getCountrySelectList({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getSelectList({ type: 3 }).then(result => {
        commit('set', { countrySelectList: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取承运商下拉列表
   * this.$store.state.common.carrierSelectList
   * this.$store.dispatch('common/getCarrierSelectList')
   */
  getCarrierSelectList({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getSelectList({ type: 8 }).then(result => {
        commit('set', { carrierSelectList: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取订单状态下拉列表
   * this.$store.state.common.statusSelectList
   * this.$store.dispatch('common/getStatusSelectList')
   */
  getStatusSelectList({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getSelectList({ type: 4 }).then(result => {
        commit('set', { statusSelectList: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取退款取消原因下拉列表
   * this.$store.state.common.cancelReasonSelectList
   * this.$store.dispatch('common/getCancelReasonSelectList')
   */
  getCancelReasonSelectList({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getSelectList({ type: 5 }).then(result => {
        commit('set', { cancelReasonSelectList: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取平台下拉列表
   * this.$store.state.common.platformOptions
   * this.$store.dispatch('common/getPlatformOptions')
   */
  getPlatformOptions({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getPlatformSelect().then(res => {
        commit('set', { platformOptions: res.data })
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取品类tree
   * this.$store.state.common.categoryTree
   * this.$store.dispatch('common/getCategoryTree')
   */
  getCategoryTree({ state, commit }) {
    return new Promise((resolve, reject) => {
      let params = {
        pageSize: 100,
        pageNumber: 1,
        status: 1
      }
      API.getCategoryList(params).then(result => {
        commit('set', { categoryTree: result.data.list })
        resolve(result.data.list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取导航树
   * this.$store.state.common.customNavList
   * this.$store.dispatch('common/customNavList')
   */
  customNavList({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getMenuCustomNav().then(result => {
        commit('set', { customNavList: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取商城广告栏
   * this.$store.state.common.adBar
   * this.$store.dispatch('common/getAdvertisingBar')
   */
  getAdvertisingBar({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getAdvertisingBar().then(result => {
        commit('set', { adBar: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取商城节日活动
   * this.$store.state.common.festivaiActivity
   * this.$store.dispatch('common/getFestivaiActivity')
   */
  getFestivaiActivity({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getDiscountList({
        pageNumber: 1,
        pageSize: 6,
        type: 3,
        status: 1,
        sortType: 3
      }).then(result => {
        commit('set', { festivaiActivity: result.data.list })
        resolve(result.data.list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取商城广告栏
   * this.$store.state.common.albumTopList
   * this.$store.dispatch('common/getAlbumModuleTop')
  */
  getAlbumModuleTop({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getAlbumModuleTop().then(result => {
        commit('set', { albumTopList: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取ip信息
   * this.$store.state.common.ipInfoObjec
   * this.$store.dispatch('common/getOpenIpInfo')
   */
  getOpenIpInfo({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getOpenIpInfo().then(result => {
        commit('set', { ipInfoObjec: result.data })
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getShoppingCarIsNeedTips({ state, commit }) {
    return new Promise((resolve, reject) => {
      API.getUserBehaviorConfig(3).then(res => {
        if (res.code === 10000 && res.data) {
          commit('set', { shoppingCarIsNeedTips: false })
          commit('set', { shoppingCarIsNeedTipsUserId: res.data.id })
          resolve()
        }
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
